<template>
    <div v-if="floorWarning" class="stl-banner stl-banner-warning">
        <i class="fa fa-exclamation-triangle"></i>
        <span>
            총요금과 세대 청구 합계가 일치하지 않습니다 (절삭 잔차 {{ fmtWon(floorWarning.floorRemainder ?? floorWarning.diff) }}원).
            정책상 잔차 흡수 없음 — 확인 후 확정하세요.
        </span>
    </div>
</template>

<script>
import { fmtWon } from "../utils/settlementFormat.js";

export default {
    name: "NegativePoolBanner",
    props: {
        warnings: { type: Array, default: () => [] },
    },
    computed: {
        floorWarning() {
            return (this.warnings || []).find((w) => w.code === "TOTAL_NE_K") || null;
        },
    },
    methods: { fmtWon },
};
</script>
